/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
export default function Companies(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16C0 15.6318 0.298477 15.3333 0.666667 15.3333H19.3333C19.7015 15.3333 20 15.6318 20 16C20 16.3682 19.7015 16.6667 19.3333 16.6667H0.666667C0.298477 16.6667 0 16.3682 0 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.72386 0.390524C1.97391 0.140476 2.31304 0 2.66667 0H10.6667C11.0203 0 11.3594 0.140476 11.6095 0.390524C11.8595 0.640571 12 0.97971 12 1.33333V16C12 16.3682 11.7015 16.6667 11.3333 16.6667C10.9651 16.6667 10.6667 16.3682 10.6667 16V1.33333H2.66667L2.66667 16C2.66667 16.3682 2.36819 16.6667 2 16.6667C1.63181 16.6667 1.33333 16.3682 1.33333 16V1.33333C1.33333 0.979711 1.47381 0.640573 1.72386 0.390524Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 6C10.6667 5.63181 10.9651 5.33333 11.3333 5.33333H17.3333C17.687 5.33333 18.0261 5.47381 18.2761 5.72386C18.5262 5.9739 18.6667 6.31304 18.6667 6.66667V16C18.6667 16.3682 18.3682 16.6667 18 16.6667C17.6318 16.6667 17.3333 16.3682 17.3333 16V6.66667H11.3333C10.9651 6.66667 10.6667 6.36819 10.6667 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4C4 3.63181 4.29848 3.33333 4.66667 3.33333H7.33333C7.70152 3.33333 8 3.63181 8 4C8 4.36819 7.70152 4.66667 7.33333 4.66667H4.66667C4.29848 4.66667 4 4.36819 4 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33333 9.33333C5.33333 8.96514 5.63181 8.66667 6 8.66667H8.66667C9.03486 8.66667 9.33333 8.96514 9.33333 9.33333C9.33333 9.70152 9.03486 10 8.66667 10H6C5.63181 10 5.33333 9.70152 5.33333 9.33333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12.6667C4 12.2985 4.29848 12 4.66667 12H7.33333C7.70152 12 8 12.2985 8 12.6667C8 13.0349 7.70152 13.3333 7.33333 13.3333H4.66667C4.29848 13.3333 4 13.0349 4 12.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 12.6667C13.3333 12.2985 13.6318 12 14 12H15.3333C15.7015 12 16 12.2985 16 12.6667C16 13.0349 15.7015 13.3333 15.3333 13.3333H14C13.6318 13.3333 13.3333 13.0349 13.3333 12.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 9.33333C13.3333 8.96514 13.6318 8.66667 14 8.66667H15.3333C15.7015 8.66667 16 8.96514 16 9.33333C16 9.70152 15.7015 10 15.3333 10H14C13.6318 10 13.3333 9.70152 13.3333 9.33333Z"
        fill="currentColor"
      />
    </svg>
  )
}
